<template>
	<div class="omapi-card__third omapi-campaign-settings__right-column">
		<campaigns-publish :changed="changed" :saving="saving" :disabled="hasError">
			<campaigns-users-setting :campaign-id="campaignId" />
			<campaigns-status-setting
				:campaign-id="id"
				:new-status="newStatus"
				:status-text="statusText"
				v-on="$listeners"
			/>
		</campaigns-publish>

		<common-card v-if="!hasError" class="omapi-rules-list__wrapper">
			<template #title>Display Rules Summary</template>
			<campaigns-rule-summary-wrap :campaign="campaign" />
		</common-card>
	</div>
</template>

<script lang="js">
import { campaign } from '@/campaigns/mixins/campaign'
import { mapGetters } from 'vuex'

export default  {
	mixins : [ campaign ],
	props  : {
		/**
		 * Campaign Id
		 */
		campaignId : {
			type : String,
			default: '',
		},
		/**
		 * Campaign status
		 */
		newStatus : {
			type : String,
			default: '',
		},
		/**
		 * Campaign status
		 */
		statusText : {
			type : String,
			default: '',
		},
		changed : Boolean,
		saving  : Boolean,
	},
	computed : {
		...mapGetters('campaigns', [ 'getCampaign', 'hasError' ]),
		/**
		 * Get the campaign object.
		 * @returns {Object} The campaign object.
		 */
		campaign () {
			return this.getCampaign(this.campaignId)
		},

	},
};
</script>
